import { UserCategory } from '../../../Model/User';

import texts from './texts.json';

const ALL_CLIENTS = 'ALL_CLIENTS';

const ManageClientsTabsConfig = {
  [UserCategory.OTHER]: {
    label: texts.tabLabels[UserCategory.OTHER],
  },
  [UserCategory.AI_FRIEND]: {
    label: texts.tabLabels[UserCategory.AI_FRIEND],
  },
  [UserCategory.CHALLENGES]: {
    label: texts.tabLabels[UserCategory.CHALLENGES],
  },
  [UserCategory.FREE_CLIENTS]: {
    label: texts.tabLabels[UserCategory.FREE_CLIENTS],
  },
  [ALL_CLIENTS]: {
    label: texts.tabLabels[ALL_CLIENTS],
  },
};

export {
  ManageClientsTabsConfig,
  ALL_CLIENTS,
};
